import Mui5 from "components/mui5";
import * as Components from "./GroupsTable.components";
import GroupsTableRow from "./GroupsTableRow";
import GroupsTableHeader from "./GroupsTableHeader";
import { Group } from "contexts/GroupsContext/GroupsContext";
import GroupsTableControls from "./GroupsTableControls";
import Tables from "components/Tables";
import NoDataWrapper from "components/NoDataWrapper";
import useSortGroups from "./hooks/useSortGroups";
import useSearchGroups from "./hooks/useSearchGroups";

interface GroupsTableProps {
  groups: Group[];
}

function GroupsTable(props: GroupsTableProps) {
  const sortedGroups = useSortGroups(props.groups);
  const filteredGroups = useSearchGroups(sortedGroups);

  return (
    <Mui5.Paper component={Components.CardWrapper}>
      <GroupsTableControls />
      <GroupsTableHeader />
      <Tables.Components.RowsBox>
        <NoDataWrapper
          hasData={Boolean(filteredGroups.length)}
          fallback={<Tables.Components.Skeleton text={<Components.NoResultsFallback />} />}
        >
          <Components.ScrollBox>
            {filteredGroups.map((group) => (
              <GroupsTableRow key={group.id} {...group} />
            ))}
          </Components.ScrollBox>
        </NoDataWrapper>
      </Tables.Components.RowsBox>
    </Mui5.Paper>
  );
}

export default GroupsTable;
